export const gridToLatLon = (grid) => {
  if (!grid || grid.length < 4) return null;

  grid = grid.toUpperCase();

  const lat1 = grid.charCodeAt(1) - 65;
  const lon1 = grid.charCodeAt(0) - 65;
  const lat2 = parseInt(grid.charAt(3));
  const lon2 = parseInt(grid.charAt(2));

  // 4 karakterli grid merkezi
  let lat = -90 + (lat1 * 10) + lat2 + 0.5;
  let lon = -180 + (lon1 * 20) + (lon2 * 2) + 1;

  // 6 karakterli grid varsa daha hassas hesapla
  if (grid.length >= 6) {
    const lat3 = grid.charCodeAt(5) - 65;
    const lon3 = grid.charCodeAt(4) - 65;
    
    // Önceki merkez ofsetini çıkarıp yeni hassas ofseti ekle
    lat = lat - 0.5 + (lat3 * (1/24)) + (1/48);
    lon = lon - 1 + (lon3 * (2/24)) + (1/24);
  }

  return [lat, lon];
};